module.exports = __webpack_public_path__ + "static/about.a6382d60.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/about.mp4
// module id = 1021
// module chunks = 35783957827783